/*eslint-disable */

import Vue from 'vue'
import moment from 'moment';

Vue.filter('dateformat', (arg) => {
  return moment(arg).locale('en').format('MMM DD, YYYY')
})
Vue.filter('chattimeformat', (arg) => {
  return moment(arg).locale('en').format('h:mm a')
})
Vue.filter('LocalDateFormat', (arg) => {
  return moment(arg).locale('en').local().format('MMM DD, YYYY')
})
Vue.filter('LocalTimeFormat', (arg) => {
  return moment(arg).locale('en').local().format('h:mm a')
})